module.exports = __webpack_public_path__ + "static/media/file-line.abb6026c.svg";